// Styles
import '../sass/style.scss';



/*
===========================================
Navigation
===========================================
*/
// Menu Burger - Mobile animation
(() => {
  const navbarMenu = document.getElementById('navbar');
  const burgerMenu = document.getElementById('burger');
  const overlayMenu = document.getElementById('overlay');
	const mediaSize = 1296;

  // Toggle Menu Function
  burgerMenu.addEventListener('click', toggleMenu);
  overlayMenu.addEventListener('click', toggleMenu); // Close the navbarMenu when clicking outside

  function toggleMenu() {
    navbarMenu.classList.toggle('active');
    overlayMenu.classList.toggle('active');
    // document.body.classList.toggle('hidden-scrolling');
  }

  // Collapse SubMenu Function
  navbarMenu.addEventListener('click', (e) => {
    if (e.target.hasAttribute('data-toggle') && window.innerWidth <= mediaSize) {
      e.preventDefault();
      const menuItemHasChildren = e.target.parentElement;

      // If menu-item-has-children is Expanded, then Collapse It
      if (menuItemHasChildren.classList.contains('active')) {
        collapseSubMenu();
				
      } else {
        // Collapse the Existing Expanded menu-item-has-children
        if (navbarMenu.querySelector('.menu-item-has-children.active')) {
          collapseSubMenu();
        }
        // Expanded the New menu-item-has-children
        menuItemHasChildren.classList.add('active');
        const subMenu = menuItemHasChildren.querySelector('.sub-menu');
        subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
      }
    }
  });

  function collapseSubMenu() {
    navbarMenu.querySelector('.menu-item-has-children.active .sub-menu').removeAttribute('style');

    navbarMenu.querySelector('.menu-item-has-children.active').classList.remove('active');
  }

	// function resizeFix() {
  //   // If navbarMenu is Open, then Close It
	// 	if (navbarMenu.classList.contains('active')) {
	// 		toggleMenu();
	// 	}
  //   // If menu-item-has-children is Expanded, then Collapse It
	// 	if (navbarMenu.querySelector('.menu-item-has-children.active')) {
	// 		collapseSubMenu();
	// 	}
  // }

  // Fixed Resize Screen Function
  window.addEventListener('resize', () => {
    // If navbarMenu is Open, then Close It
		if (navbarMenu.classList.contains('active')) {
			toggleMenu();
		}
    // If menu-item-has-children is Expanded, then Collapse It
		if (navbarMenu.querySelector('.menu-item-has-children.active')) {
			collapseSubMenu();
		}
  });
})();

